// loadingSlice.js
import { createSlice } from '@reduxjs/toolkit';

const loadingSlice = createSlice({
  name: 'loading',
  initialState: {},
  reducers: {
    setLoading: (state, action) => {
      state[action.payload] = true;
    },
    setLoaded: (state, action) => {
      state[action.payload] = false;
    },
  },
});

export const loadingMiddleware = (store) => (next) => (action) => {
  if(action.type.endsWith('/pending')) {
    // Dispatch a loading action when a request is initiated
    store.dispatch(setLoading(action.type.substring(0, action.type.length - '/pending'.length)));
  } else if(action.type.endsWith('/fulfilled')) {
    // Dispatch a completion action when the request is fulfilled
    store.dispatch(setLoaded(action.type.substring(0, action.type.length - '/fulfilled'.length)));
  } else if(action.type.endsWith('/rejected')) {
    // Dispatch a completion action when the request is rejected
    store.dispatch(setLoaded(action.type.substring(0, action.type.length - '/rejected'.length)));
  }

  return next(action);
};

export const { setLoading, setLoaded } = loadingSlice.actions;
export default loadingSlice.reducer;
